/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_CtaInputs */

const en_coaches_page_cta = /** @type {(inputs: Coaches_Page_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See free times`)
};

const pl_coaches_page_cta = /** @type {(inputs: Coaches_Page_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobacz wolne terminy`)
};

/**
* | output |
* | --- |
* | "See free times" |
*
* @param {Coaches_Page_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_cta = /** @type {((inputs?: Coaches_Page_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_cta(inputs)
	return en_coaches_page_cta(inputs)
});